module.exports = __webpack_public_path__ + "static/media/banner_animation.6db20551.mp4";